import { useRef, useState, useEffect } from 'react';
import { Box } from '@mui/material';

export interface FeatureItemProps {
  businessImgUrl: string;
  year?: string;
  title: string[];
  width?: number;
}
export default function BusinessItem({ businessImgUrl, year, title, width }: FeatureItemProps) {
  const [imgHeight, setImgHeight] = useState<number>(0);
  const [imgWidth, setImgWidth] = useState<number>(0);
  const titleRef = useRef<HTMLDivElement | null>(null);
  const [titleWidth, setTitleWidth] = useState<number>(0);

  useEffect(() => {
    if (!titleRef.current) return;

    const el = titleRef.current;
    const updateWidth = () => setTitleWidth(el.getBoundingClientRect().width);

    updateWidth();

    const ro = new ResizeObserver(updateWidth);
    ro.observe(el);

    return () => ro.disconnect();
  }, []);

  const computedWidth = Math.max(width || 0, imgWidth, titleWidth);

  return (
    <Box
      className="business-item"
      sx={{
        width: computedWidth || 'auto',
        height: imgHeight ? `${imgHeight + 110}px` : 'auto',
        transition: 'height 0.2s ease',
      }}
    >
      <Box className="business-item-content-wrap">
        <Box
          sx={{
            height: `80px`,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            padding: '0.25rem',
          }}
        >
          <img
            src={businessImgUrl}
            alt="사업 배너"
            onLoad={(e) => {
              const target = e.currentTarget;
              setImgHeight(target.naturalHeight);
              setImgWidth(target.naturalWidth);
            }}
            style={{
              width: imgWidth ? `${imgWidth}px` : 'auto',
              height: imgHeight ? `${imgHeight}px` : 'auto',
              objectFit: 'none',
              display: 'block',
            }}
          />
        </Box>

        <div className="business-item-year-wrap">
          <div className="year">{year}년</div>
        </div>
        <div className="business-item-title-wrap">
          <div className="title">
            {title.map((line, idx) => (
              <div key={idx}>{line}</div>
            ))}
          </div>
        </div>
      </Box>
    </Box>
  );
}
